import { defineChart, lineY } from "@tanstack/charts/universal"
import {
  annotationsOf,
  backdropsOf,
  dailySpecOf,
  dayAxis,
  daySpanScale,
  dayPickingOf,
  valueAxis,
  valuesOf,
} from "./daily.ts"
import type { DailyChartInput } from "./input.ts"

/**
 * Each series as a line across the UTC days, a day of nothing at zero. A day whose history isn't
 * known breaks every line and stands in a muted band, so a gap never reads as nothing happening.
 */
export function dailyTrend<K extends string>(input: DailyChartInput<K>) {
  const values = valuesOf(input)
  const y = valueAxis(Math.max(0, ...values.map(({ value }) => value ?? 0)), input)
  return defineChart({
    marks: [
      ...backdropsOf(input, y.top),
      lineY(values, {
        id: "lines",
        x: "day",
        y: "value",
        z: (point) => point.series,
        color: (point) => point.series,
        strokeWidth: 2,
      }),
      ...annotationsOf(input, y.top),
    ],
    scales: { x: dayAxis(input), y: y.options, ...daySpanScale(input) },
    ...dailySpecOf(input),
    ...dayPickingOf(input),
  })
}
